import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=f5c6ba4c&scoped=true&"
import script from "./DropArea.vue?vue&type=script&lang=js&"
export * from "./DropArea.vue?vue&type=script&lang=js&"
import style0 from "./DropArea.vue?vue&type=style&index=0&id=f5c6ba4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c6ba4c",
  null
  
)

export default component.exports